import { SET_QUOTATIONS } from "../../actionTypes";

const initialState = {
  data: null,
};

// Reducer
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_QUOTATIONS:
      return {
        ...state,
        data: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
